import { VipCustomerFormType } from 'components/vip-customers/VipCustomerForm';

export const updateVipCustomerInitialValues: Partial<VipCustomerFormType> = {};
